import * as APIM from '@common/utils/dist/models/api-messages.js';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {KeyUtilsPL2 as KU} from '@common/utils/dist/utils/key-utils-pl2.js';
import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';
import {EntryEventChainOutput, EntryEventHandler} from './entry-event-core';

export class AssignmentCompleteChangeHandler implements EntryEventHandler<
  EntryEventChainOutput,
  EntryEventChainOutput
> {
  nextHandler: EntryEventHandler<EntryEventChainOutput, any>;

  handle(input: EntryEventChainOutput): EntryEventChainOutput {
    const updates = input.changes[APIM.EventIntent.EntryBatchUpdate];
    if (U.isEmpty(updates)) {
      return this.nextHandler.handle(input);
    }

    const assignmentCompleteUpdates: PL2.AnyPartialEntryWithId[] = [];

    for (const entry of updates) {
      if (!KU.isType(PL2.EntryType.Assignment, entry) || !('isC' in entry)) {
        continue;
      }

      const nextIsC = (entry as Partial<PL2.AssignmentEntry>).isC;

      assignmentCompleteUpdates.push({
        mId: entry.mId,
        sK: entry.sK,
        isC: nextIsC,
      } as PL2.AnyPartialEntryWithId);
    }

    if (assignmentCompleteUpdates.length > 0) {
      if (U.isEmpty(input.changes[APIM.EventIntent.AssignmentCompleteUpdate])) {
        input.changes[APIM.EventIntent.AssignmentCompleteUpdate] = [];
      }
      input.changes[APIM.EventIntent.AssignmentCompleteUpdate].push(
        ...assignmentCompleteUpdates,
      );
    }

    return this.nextHandler.handle(input);
  }
}
